import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledHeadingContainer = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
  }
`;

export const StyledHeading = styled.h6<{
  color?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) =>
    props?.color ? props.color : themeGet('colors.text.default')};

  &:not(:last-child) {
    margin-bottom: 11px;
  }

  > svg {
    margin-right: 7px;
  }

  b {
    color: inherit;
  }
`;

export const StyledCardsWrapper = styled.div<{
  columns?: number;
}>`
  display: grid;
  grid-template-columns: repeat(${(props) => props?.columns || 2}, 1fr);
  grid-gap: 40px;
  align-items: flex-start;
`;

export const StyledPlantsWrapper = styled(StyledCardsWrapper)`
  position: relative;
  max-width: 828px;
  width: 100%;
  margin: 0 auto;
  grid-gap: 100px;

  &:not(:last-child) {
    margin-bottom: 32px;
  }
`;

export const StyledPositionIcon = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
